import React from 'react'
import CallSummaryCard from './call-summary-card'
import BasicCallCard from './basic-call-card'
import { Message } from './types'

interface CallCardProps {
  message: Message
  showTimestamp: boolean
  formatTimestamp: (timestamp: string) => string
}

const CallCard: React.FC<CallCardProps> = ({
  message,
  showTimestamp,
  formatTimestamp,
}) => {
  const messageType = message.message_type
  const callSummary = message.call?.summary || message.call?.recording?.summary
  const hasSummary = callSummary?.header !== undefined

  // Route to appropriate component based on call type
  if (messageType === 'call_processed' && hasSummary) {
    return (
      <CallSummaryCard
        message={message}
        showTimestamp={showTimestamp}
        formatTimestamp={formatTimestamp}
      />
    )
  }

  // For all other call events
  return (
    <BasicCallCard
      message={message}
      showTimestamp={showTimestamp}
      formatTimestamp={formatTimestamp}
    />
  )
}

export default CallCard
